import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSendCorporateAccountVerificationEmailToLegalHeadFirstHeadMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientSendCorporateAccountVerificationEmailToLegalHeadFirstHead =
  () => {
    const [handle, { data, loading, error: apolloError }] =
      useLegalClientSendCorporateAccountVerificationEmailToLegalHeadFirstHeadMutation();

    const error = useError(apolloError);

    return {
      data: {
        resendTime:
          data
            ?.legalClientSendCorporateAccountVerificationEmailToLegalHeadFirstHead
            ?.resendTime,
      },
      loading,
      error,
      send: useCallback(
        async (id: string, legalHeadId: string, firstHeadId: string) => {
          const res = await handle({
            variables: { id, legalHeadId, firstHeadId },
          });
          return {
            resendTime:
              res.data
                ?.legalClientSendCorporateAccountVerificationEmailToLegalHeadFirstHead
                ?.resendTime,
          };
        },
        [handle]
      ),
    };
  };
